import {
  CHANGE_DATE,
  GET_SHIFTS_SUCCESS,
  ADD_SHIFT,
  UPDATE_ISLUNCH,
  UPDATE_EMPLOYEEID,
  UPDATE_TITLE,
  UPDATE_NETSALES,
  UPDATE_BEER,
  CALCULATE_SHIFT_TIPS,
  UPDATE_BYBOTTLE,
  UPDATE_FOOD,
  UPDATE_LIQUOR,
  UPDATE_MIXEDCOCKTAILS,
  UPDATE_NABEVERAGE,
  UPDATE_SAKE,
  UPDATE_SUSHI,
  UPDATE_WINE,
  UPDATE_CCTIP,
  UPDATE_FINALTIPOUT,
  CREATE_SHIFT_SUCCESS,
  DELETE_SHIFTS_SUCCESS,
  DELETE_SHIFT_SUCCESS,
  UPDATE_SUSHITIP,
  UPDATE_BARTIP,
  UPDATE_EXPOTIP,
  UPDATE_HOSTTIP,
  UPDATE_BUSSERTIP,
  UPDATE_HOSTPERCENTAGE,
  SPLIT_LUNCH_SERVER_TIPS,
  UPDATE_BARRATIO,
  VALIDATE_LUNCH_TIPS,
  VALIDATE_DINNER_TIPS,
  UPDATE_EXPORATIO,
  UPDATE_HOSTRATIO,
  UPDATE_BUSSERRATIO,
  UPDATE_SHIFT_SUCCESS,
  UPDATE_EXPOPERCENTAGE,
  UPDATE_BUSSERPERCENTAGE,
  UPDATE_SUSHIPERCENTAGE,
  UPDATE_BARPERCENTAGE,
  UPDATE_LUNCHEXPOPERCENTAGE,
  GET_RESTAURANT_SUCCESS,
  SPLIT_DINNER_SERVER_TIPS,
  GET_SHIFTS_FAIL,
  DELETE_SHIFT_FAIL,
  UPDATE_HOSTFACTOR,
  UPDATE_EXPOFACTOR,
  UPDATE_BUSSERFACTOR,
  UPDATE_NOTES,
  UPDATE_SERVERRATIO,
  COPY_SHIFT,
} from '../actions/actionTypes';

import {
  calculateSplittedLunchServerTips,
  calculateTotalLunchHostTips,
  calculateTotalLunchExpoTips,
  calculateTotalLunchToGoTips,
  calculateLunchShiftTips,
  calculateTotalLunchTipOut,
  validateLunchTipPool,
  calculateLunchTipPool,
} from './lunchTipCal';

import {
  calculateTotalHostTips,
  calculateTotalSushiTips,
  calculateTotalBarTips,
  calculateTotalBusserTips,
  calculateTotalToGoTips,
  calculateTotalExpoTips,
  calculateTotalDinnerTipOut,
  calculateShiftTips,
  calculateSplittedDinnerServerTips,
  validateDinnerTipPool,
  calculateDinnerTipPool,
} from './dinnerTipCal';

import { logout } from '../actions';

const today = new Date(Date.now() - 86400000);

const dailyShifts = (
  state = {
    date: today,
    shifts: [],
    restaurant: {
      ID: 1,
      SushiPercentage: 0,
      BarPercentage: 0,
      HostPercentage: 0,
      ExpoPercentage: 0,
      BusserPercentage: 0,
      LunchExpoPercentage: 0,
    },

    hostFactor: 1,
    expoFactor: 1,
    busserFactor: 1,

    totalLunchHostTips: 0,
    totalLunchToGoTips: 0,
    totalLunchTipOut: 0,
    lunchTipPool: 0,
    totalHostTips: 0,
    totalSushiTips: 0,
    totalBarTips: 0,
    totalExpoTips: 0,
    totalBusserTips: 0,
    totalDinnerTipOut: 0,
    dinnerTipPool: 0,
  },
  action,
) => {
  // let totalLunchHostTips = 0
  // let totalLunchToGoTips = 0
  // let totalLunchTipOut = 0
  switch (action.type) {
    case GET_RESTAURANT_SUCCESS:
      return {
        ...state,
        restaurant: action.payload,
      };
    case CHANGE_DATE:
      return {
        ...state,
        date: action.payload,
      };
    case GET_SHIFTS_SUCCESS:
      // const totalLunchHostTips = Number(calculateTotalLunchHostTips(action.payload).toFixed(2))
      // const totalLunchToGoTips = Number(calculateTotalLunchToGoTips(action.payload).toFixed(2))
      // const totalLunchTipOut = Number(calculateTotalLunchTipOut(action.payload).toFixed(2))

      // const totalHostTips = Number(calculateTotalHostTips(action.payload).toFixed(2))
      // const totalSushiTips = Number(calculateTotalSushiTips(action.payload).toFixed(2))
      // const totalBarTips = Number(calculateTotalBarTips(action.payload).toFixed(2))
      // const totalExpoTips = Number(calculateTotalExpoTips(action.payload).toFixed(2))
      // const totalBusserTips = Number(calculateTotalBusserTips(action.payload).toFixed(2))
      // const totalToGoTips = Number(calculateTotalToGoTips(action.payload).toFixed(2))
      // const totalDinnerTipOut = Number(calculateTotalDinnerTipOut(action.payload).toFixed(2))

      const allTotalAfterGet = recalculateAllTotal(action.payload);

      return {
        ...state,
        ...allTotalAfterGet,
        shifts: action.payload.map((item) => {
          return { ...item, IsSaved: true };
        }),
      };
    ///return gotState
    case GET_SHIFTS_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case ADD_SHIFT:
      return {
        ...state,
        shifts: [...state.shifts, action.payload],
      };
    case COPY_SHIFT:
      const shiftNumber = action.payload.shiftNumber;
      if (shiftNumber > state.shifts.length) {
        return state;
      } else {
        const newShift = state.shifts[shiftNumber];
        newShift.Index = state.shifts.length;
        newShift.IsSaved = false;
        return {
          ...state,
          shifts: [...state.shifts, newShift],
        };
      }
    case UPDATE_ISLUNCH:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        IsLunch: action.payload.value,
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_EMPLOYEEID:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        EmployeeID: Number(parseInt(action.payload.value)),
        IsSaved: false,
      };
      if (Number(parseInt(action.payload.value)) === 1) {
        state.shifts[action.payload.sid] = {
          ...state.shifts[action.payload.sid],
          EmployeeID: Number(parseInt(action.payload.value)),
          Title: 'TOGO',
        };
      }
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_TITLE:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        Title: action.payload.value,
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_NETSALES:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        NetSales: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_BEER:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        Beer: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_BYBOTTLE:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        ByBottle: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_FOOD:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        Food: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_LIQUOR:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        Liquor: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_MIXEDCOCKTAILS:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        MixedCocktails: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_NABEVERAGE:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        NABeverage: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_SAKE:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        Sake: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_SUSHI:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        IsSaved: false,
        Sushi: Number(parseFloat(action.payload.value).toFixed(2)),
        SushiTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_WINE:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        Wine: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_SERVERRATIO:
      if (action.payload.value !== 1) {
        state.shifts[action.payload.sid] = {
          ...state.shifts[action.payload.sid],
          ServerRatio: Number(parseFloat(action.payload.value).toFixed(2)),
          IsSaved: false,
          NetSales: 0,
          CCTip: 0,
          CCTipFee: 0,
          SushiTip: 0,
          HostTip: 0,
          BarTip: 0,
          BusserTip: 0,
          ExpoTip: 0,
          FinalTipOut: 0,
        };
        return {
          ...state,
          shifts: state.shifts,
        };
      } else {
        return state;
      }
    case UPDATE_BARRATIO:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        BarRatio: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        HostTip: 0,
        BarTip: 0,
        BusserTip: 0,
        ExpoTip: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_EXPORATIO:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        ExpoRatio: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_HOSTRATIO:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        HostRatio: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_BUSSERRATIO:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        BusserRatio: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_SUSHITIP:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        SushiTip: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_BARTIP:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        BarTip: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_EXPOTIP:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        ExpoTip: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_HOSTTIP:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        HostTip: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_BUSSERTIP:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        BusserTip: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_CCTIP:
      // const ccTip = Number(parseFloat(action.payload.value).toFixed(2));
      // let ccTipFee;
      // if (state.restaurant.ID === 3) {
      //   ccTipFee = Number((ccTip * 0.03).toFixed(2));
      // } else {
      //   ccTipFee = Number((ccTip * 0.025).toFixed(2));
      // }
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        CCTip: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
        CCTipFee: 0,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_FINALTIPOUT:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        FinalTipOut: Number(parseFloat(action.payload.value).toFixed(2)),
        IsSaved: false,
      };
      // const currentShift = state.shifts[action.payload.sid]
      // if (currentShift.IsLunch) {
      //   if (currentShift.Title==='Host') {
      //     totalLunchTipsConsumed = calculateTotalLunchTipsConsumed(state)
      //   }
      // } else {

      // }
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_SUSHIPERCENTAGE:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          SushiPercentage: action.payload.value,
        },
      };
    case UPDATE_BARPERCENTAGE:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          BarPercentage: action.payload.value,
        },
      };
    case UPDATE_HOSTPERCENTAGE:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          HostPercentage: action.payload.value,
        },
      };
    case UPDATE_EXPOPERCENTAGE:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          ExpoPercentage: action.payload.value,
        },
      };
    case UPDATE_BUSSERPERCENTAGE:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          BusserPercentage: action.payload.value,
        },
      };
    case UPDATE_LUNCHEXPOPERCENTAGE:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          LunchExpoPercentage: action.payload.value,
        },
      };
    case UPDATE_HOSTFACTOR:
      return {
        ...state,
        hostFactor: action.payload.value,
      };
    case UPDATE_EXPOFACTOR:
      return {
        ...state,
        expoFactor: action.payload.value,
      };
    case UPDATE_NOTES:
      state.shifts[action.payload.sid] = {
        ...state.shifts[action.payload.sid],
        IsSaved: false,
        Notes: action.payload.value,
      };
      return {
        ...state,
        shifts: state.shifts,
      };
    case UPDATE_BUSSERFACTOR:
      return {
        ...state,
        busserFactor: action.payload.value,
      };
    case SPLIT_LUNCH_SERVER_TIPS:
      return {
        ...state,
        shifts: calculateSplittedLunchServerTips(state.shifts),
      };
    case SPLIT_DINNER_SERVER_TIPS:
      return {
        ...state,
        shifts: calculateSplittedDinnerServerTips(state.shifts),
      };
    case VALIDATE_LUNCH_TIPS:
      validateLunchTipPool(state);
      return state;
    case VALIDATE_DINNER_TIPS:
      validateDinnerTipPool(state);
      return state;
    case CALCULATE_SHIFT_TIPS:
      const shift = state.shifts[action.payload.sid];
      if (shift.IsLunch) {
        state.shifts[action.payload.sid] = calculateLunchShiftTips(
          state,
          state.shifts[action.payload.sid],
        );
        // post lunch shift tip calculation
        if (shift.Title === 'Host') {
          const finalHostTipOut = state.shifts[action.payload.sid].FinalTipOut;
          state.shifts = state.shifts.map((item) => {
            if (item.IsLunch && item.Title === 'Host') {
              item = { ...item, FinalTipOut: finalHostTipOut };
            }
            return item;
          });
          // recalculate all the expo shifts
          const expoShifts = state.shifts.filter(
            (i) => i.IsLunch === true && i.Title === 'Expo',
          );
          if (expoShifts.length > 0) {
            state.shifts = state.shifts.map((item) => {
              if (item.IsLunch === true && item.Title === 'Expo') {
                item = calculateLunchShiftTips(state, item);
              }
              return item;
            });
          }
          const totalLunchTipOut = Number(
            calculateTotalLunchTipOut(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalLunchTipOut,
            shifts: state.shifts,
          };
        } else if (shift.Title === 'Expo') {
          // recalculate other expo shifts
          const otherExpoShifts = state.shifts.filter(
            (i) =>
              i.IsLunch === true &&
              i.Title === 'Expo' &&
              i.sid !== action.payload.sid,
          );
          if (otherExpoShifts.length > 0) {
            state.shifts = state.shifts.map((item) => {
              if (
                (i) =>
                  i.IsLunch === true &&
                  i.Title === 'Expo' &&
                  i.sid !== action.payload.sid
              ) {
                item = calculateLunchShiftTips(state, item);
              }
              return item;
            });
          }

          // recalculate all the host shifts since it's evenly splitted
          const hostShifts = state.shifts.filter(
            (i) => i.IsLunch === true && i.Title === 'Host',
          );
          if (hostShifts.length > 0) {
            let firstHostShift = hostShifts[0];
            firstHostShift = calculateLunchShiftTips(state, firstHostShift);
            const finalHostTipOut = firstHostShift.FinalTipOut;
            state.shifts = state.shifts.map((item) => {
              if (item.IsLunch === true && item.Title === 'Host') {
                item = { ...item, FinalTipOut: finalHostTipOut };
              }
              return item;
            });
          }

          const totalLunchTipOut = Number(
            calculateTotalLunchTipOut(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalLunchTipOut,
            shifts: state.shifts,
          };
        } else if (shift.Title === 'Server') {
          // recalculate tip pool
          const totalLunchHostTips = Number(
            calculateTotalLunchHostTips(state.shifts).toFixed(2),
          );
          const totalLunchExpoTips = Number(
            calculateTotalLunchExpoTips(state.shifts).toFixed(2),
          );
          const totalLunchTipOut = Number(
            calculateTotalLunchTipOut(state.shifts).toFixed(2),
          );
          const lunchTipPool = Number(
            calculateLunchTipPool(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalLunchHostTips,
            totalLunchExpoTips,
            totalLunchTipOut,
            lunchTipPool,
            shifts: state.shifts,
          };
        } else if (shift.EmployeeID === 1) {
          const totalLunchToGoTips = Number(
            calculateTotalLunchToGoTips(state.shifts).toFixed(2),
          );
          const lunchTipPool = Number(
            calculateLunchTipPool(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalLunchToGoTips,
            lunchTipPool,
            shifts: state.shifts,
          };
        }
      } else {
        // Calculate shift tips for dinner
        state.shifts[action.payload.sid] = calculateShiftTips(
          state,
          state.shifts[action.payload.sid],
        );
        // post shift tip calculation
        if (shift.Title === 'Server' || shift.Title === 'Bartender') {
          // recalculate tip pool
          const totalHostTips = Number(
            calculateTotalHostTips(state.shifts).toFixed(2),
          );
          const totalSushiTips = Number(
            calculateTotalSushiTips(state.shifts).toFixed(2),
          );
          const totalBarTips = Number(
            calculateTotalBarTips(state.shifts).toFixed(2),
          );
          const totalExpoTips = Number(
            calculateTotalExpoTips(state.shifts).toFixed(2),
          );
          const totalBusserTips = Number(
            calculateTotalBusserTips(state.shifts).toFixed(2),
          );
          const totalDinnerTipOut = Number(
            calculateTotalDinnerTipOut(state.shifts).toFixed(2),
          );
          const dinnerTipPool = Number(
            calculateDinnerTipPool(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalHostTips,
            totalSushiTips,
            totalBarTips,
            totalExpoTips,
            totalBusserTips,
            totalDinnerTipOut,
            dinnerTipPool,
            shifts: state.shifts,
          };
        } else if (shift.EmployeeID === 1) {
          const totalToGoTips = calculateTotalToGoTips(state.shifts);
          const dinnerTipPool = Number(
            calculateDinnerTipPool(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalToGoTips,
            dinnerTipPool,
            shifts: state.shifts,
          };
        } else if (shift.Title === 'Host') {
          // recalculate all the host shifts since it's evenly splitted
          const finalHostTipOut = state.shifts[action.payload.sid].FinalTipOut;
          state.shifts = state.shifts.map((item) => {
            if (item.IsLunch === false && item.Title === 'Host') {
              item = { ...item, FinalTipOut: finalHostTipOut };
            }
            return item;
          });
          // recalculate all the expo shifts
          const expoShifts = state.shifts.filter(
            (i) => i.IsLunch === false && i.Title === 'Expo',
          );
          if (expoShifts.length > 0) {
            state.shifts = state.shifts.map((item) => {
              if (item.IsLunch === false && item.Title === 'Expo') {
                item = calculateShiftTips(state, item);
              }
              return item;
            });
          }
          // recalculate all the lunch host shifts
          const lunchHostShifts = state.shifts.filter(
            (i) => i.IsLunch === true && i.Title === 'Host',
          );
          if (lunchHostShifts.length > 0) {
            state.shifts = state.shifts.map((item) => {
              if (item.IsLunch === true && item.Title === 'Host') {
                item = calculateLunchShiftTips(state, item);
              }
              return item;
            });
          }
          const totalDinnerTipOut = Number(
            calculateTotalDinnerTipOut(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalDinnerTipOut,
            shifts: state.shifts,
          };
        } else if (shift.Title === 'Expo') {
          // recalculate other expo shifts
          const otherExpoShifts = state.shifts.filter(
            (i) =>
              i.IsLunch === false &&
              i.Title === 'Expo' &&
              i.EmployeeID !== shift.EmployeeID,
          );
          if (otherExpoShifts.length > 0) {
            state.shifts = state.shifts.map((item) => {
              if (
                item.IsLunch === false &&
                item.Title === 'Expo' &&
                item.EmployeeID !== shift.EmployeeID
              ) {
                item = calculateShiftTips(state, item);
              }
              return item;
            });
          }

          // recalculate all the host shifts since it's evenly splitted
          const hostShifts = state.shifts.filter(
            (i) => i.IsLunch === false && i.Title === 'Host',
          );
          if (hostShifts.length > 0) {
            let firstHostShift = hostShifts[0];
            firstHostShift = calculateShiftTips(state, firstHostShift);
            const finalHostTipOut = firstHostShift.FinalTipOut;
            state.shifts = state.shifts.map((item) => {
              if (item.IsLunch === false && item.Title === 'Host') {
                item = { ...item, FinalTipOut: finalHostTipOut };
              }
              return item;
            });
          }
          const totalDinnerTipOut = Number(
            calculateTotalDinnerTipOut(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalDinnerTipOut,
            shifts: state.shifts,
          };
        } else if (shift.Title === 'Busser') {
          // recalculate other busser shifts
          const otherBusserShifts = state.shifts.filter(
            (i) =>
              i.IsLunch === false &&
              i.Title === 'Busser' &&
              i.EmployeeID !== shift.EmployeeID,
          );
          if (otherBusserShifts.length > 0) {
            state.shifts = state.shifts.map((item) => {
              if (
                item.IsLunch === false &&
                item.Title === 'Busser' &&
                item.EmployeeID !== shift.EmployeeID
              ) {
                item = calculateShiftTips(state, item);
              }
              return item;
            });
          }

          const totalDinnerTipOut = Number(
            calculateTotalDinnerTipOut(state.shifts).toFixed(2),
          );
          return {
            ...state,
            totalDinnerTipOut,
            shifts: state.shifts,
          };
        }
      }
      return state;
    case CREATE_SHIFT_SUCCESS:
    case UPDATE_SHIFT_SUCCESS:
      state.shifts[action.payload.Index] = action.payload;
      state.shifts[action.payload.Index].IsSavingShift = false;
      state.shifts[action.payload.Index].IsSaved = true;
      return {
        ...state,
        shifts: state.shifts,
      };
    case DELETE_SHIFT_SUCCESS:
      const filteredShifts = state.shifts.filter(
        (i) => i.ID !== parseInt(action.payload.ID),
      );
      const newAllTotal = recalculateAllTotal(filteredShifts);
      return {
        ...state,
        ...newAllTotal,
        shifts: filteredShifts,
      };
    case DELETE_SHIFT_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case DELETE_SHIFTS_SUCCESS:
      return {
        ...state,
        shifts: [],
      };
    default:
      return state;
  }
};

const recalculateAllTotal = (shifts) => {
  const totalLunchHostTips = Number(
    calculateTotalLunchHostTips(shifts).toFixed(2),
  );
  const totalLunchExpoTips = Number(
    calculateTotalLunchExpoTips(shifts).toFixed(2),
  );
  const totalLunchToGoTips = Number(
    calculateTotalLunchToGoTips(shifts).toFixed(2),
  );
  const totalLunchTipOut = Number(calculateTotalLunchTipOut(shifts).toFixed(2));
  const lunchTipPool = Number(calculateLunchTipPool(shifts).toFixed(2));

  const totalHostTips = Number(calculateTotalHostTips(shifts).toFixed(2));
  const totalSushiTips = Number(calculateTotalSushiTips(shifts).toFixed(2));
  const totalBarTips = Number(calculateTotalBarTips(shifts).toFixed(2));
  const totalExpoTips = Number(calculateTotalExpoTips(shifts).toFixed(2));
  const totalBusserTips = Number(calculateTotalBusserTips(shifts).toFixed(2));
  const totalToGoTips = Number(calculateTotalToGoTips(shifts).toFixed(2));
  const totalDinnerTipOut = Number(
    calculateTotalDinnerTipOut(shifts).toFixed(2),
  );
  const dinnerTipPool = Number(calculateDinnerTipPool(shifts).toFixed(2));
  return {
    totalLunchHostTips,
    totalLunchExpoTips,
    totalLunchToGoTips,
    totalLunchTipOut,
    lunchTipPool,

    totalHostTips,
    totalSushiTips,
    totalBarTips,
    totalExpoTips,
    totalBusserTips,
    totalToGoTips,
    totalDinnerTipOut,
    dinnerTipPool,
  };
};

export default dailyShifts;
